import * as Sentry from '@sentry/react';

const isProduction = !location.hostname.includes('localhost');

if (window.settings?.SENTRY_DSN) {
  Sentry.init({
    dsn: window.settings.SENTRY_DSN,
    tracesSampleRate: 1.0,
    environment: isProduction ? 'production' : 'development',
  });
}

export default Sentry;
